const _cryptoData = {};
let _rigs = [];

const observableCryptoData = new Rx.BehaviorSubject(_cryptoData);
const observableRigs = new Rx.BehaviorSubject(_rigs);

const CryptoRepository = {

    getAll(key) {

        return key ? _cryptoData[key] : _cryptoData;

    },

    replaceRigs(data) {

        if (data) {

            _rigs = data;

        }

        observableRigs.onNext(_rigs);

    },

    getAllRigs() {

        return _rigs;

    },

    replace(key, data) {

        if (key) {

            _cryptoData[key] = data;

        }

        observableCryptoData.onNext(_cryptoData);

    },

    getObservable() {

        return observableCryptoData;

    },

    getObservableRigs() {

        return observableRigs;

    },

};

export default CryptoRepository;



// WEBPACK FOOTER //
// ./scripts/common/repositories/-RFC.cryptoRepository.js